import { render } from "./FormActivation.vue?vue&type=template&id=0cc0517c&scoped=true"
import script from "./FormActivation.vue?vue&type=script&lang=js"
export * from "./FormActivation.vue?vue&type=script&lang=js"

import "./FormActivation.vue?vue&type=style&index=0&id=0cc0517c&scoped=true&lang=css"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc0517c"]])